<template>
  <div class="block new" @click="addBlock" />
</template>

<script>
import db from "../db.js";
import util from "../util.js";

export default {
  name: "new-block",
  props: ["categoryId", "customDate"],
  methods: {
    addBlock: function(event) {
      let date = this.customDate.length ? this.customDate : util.getCurrentDay();
      db.addBlock(this.categoryId, date);
    },
  },
};
</script>

<style>
.block.new {
  border-style: dashed;
  height: 1.5rem;
  width: 1.5rem;
}

.block.new.quota {
  height: 1rem;
  width: 1rem;
}

.block.new.quotaMet {
  border-color: #ccc;
}
</style>



// WEBPACK FOOTER //
// NewBlock.vue?e9fa7914